import {createMuiTheme} from "@material-ui/core"

// Tokens
import {MODERN_TOKENS, ModernTheme, ModernTokens} from "./tokens"

/*
 * `./theme.d` is NOT imported here.
 *
 * The augmentation already applies globally via tsconfig's `include`, so the
 * import was redundant — and it resolved only because CRA 3.3 happens to list
 * a bare `ts` in webpack's `moduleFileExtensions`, which makes it find
 * `theme.d.ts` and emit an empty module. Any stricter toolchain (ts-loader,
 * Vite, CRA 4+) fails the build with "Module not found: ./theme.d".
 */

export type UiThemeMode = "light" | "dark"

/**
 * Builds the Modern MUI theme for a given reading-room mode.
 *
 * Sets `palette.type` so every reused MUI surface (Dialog, TextField, Paper,
 * Checkbox) that Modern inherits from Classic gets dark styling for free, and
 * attaches the full token object as `theme.modern` for our own styles.ts files.
 */
export default function createModernTheme(mode: UiThemeMode): ModernTheme {
    const m: ModernTokens = MODERN_TOKENS[mode];

    return createMuiTheme({
        modern: m,
        palette: {
            type: mode,
            primary: {main: m.accent},
            secondary: {main: m.crit},
            error: {main: m.crit},
            background: {default: m.bg, paper: m.panel},
            text: {primary: m.ink, secondary: m.ink2},
            divider: m.line,
        },
        typography: {
            fontFamily: m.sans,
            fontSize: 13,
        },
        // the prototype has no ripples anywhere
        props: {
            MuiButtonBase: {disableRipple: true},
        },
    }) as ModernTheme
}
